module.exports = __webpack_public_path__ + "img/Truppführer_LogM.7d6a63c5.svg";